import { render, staticRenderFns } from "./Router.vue?vue&type=template&id=471f0308&"
import script from "./Router.vue?vue&type=script&lang=js&"
export * from "./Router.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports